/**
 * Canonical slug for URLs built from user-visible names (preview, ship segment, share link).
 * Do not change lightly: existing bookmarks and shared links depend on stable output.
 */
export const URL_SLUG_FALLBACK_PREVIEW = "digital-memory";
export const URL_SLUG_FALLBACK_SHIP = "ship";

export interface ToUrlFriendlySlugOptions {
  /** Used when input is empty or slugifies to empty. */
  emptyFallback?: string;
}

/**
 * Produces a lowercase hyphenated segment safe for path use.
 * Order: normalize whitespace to hyphens, strip non [a-z0-9-], collapse hyphens, trim edge hyphens.
 */
export function toUrlFriendlySlug(
  name: string | null | undefined,
  options?: ToUrlFriendlySlugOptions
): string {
  const emptyFallback =
    options && options.emptyFallback ? options.emptyFallback : URL_SLUG_FALLBACK_PREVIEW;

  if (name == null || String(name).trim() === "") {
    return emptyFallback;
  }

  const slug = String(name)
    .toLowerCase()
    .trim()
    .replace(/\s+/g, "-")
    .replace(/[^a-z0-9\-]/g, "")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");

  return slug || emptyFallback;
}
